import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LocalStoreHelper } from 'src/utils/LocalStoreHelper';

export const useUrlUiSettings = () => {
    const { hash } = useLocation();

    useEffect(() => {
        const hashParams = hash.slice(1).split('&');
        const hashParamsEntries: UiSettingsEntry[] = hashParams.map(
            (param: string) => {
                return param.split('=');
            },
        );
        const uiSettingsEntries: UiSettingsEntry[] = hashParamsEntries
            .filter((hashParamsEntry) => {
                return hashParamsEntry[0].startsWith(
                    uiSettingsHashParamsPrefix,
                );
            })
            .map((uiSettingsEntry) => {
                const [key, value] = uiSettingsEntry;

                return [
                    key.slice(uiSettingsHashParamsPrefix.length + 1),
                    value,
                ];
            });
        const localStorageUiSettings =
            LocalStoreHelper.getItem<Record<string, any>>(
                uiSettingsLocalStorageKey,
            ) || {};

        uiSettingsEntries.forEach((uiSettingsEntry) => {
            const [key, value] = uiSettingsEntry;
            if (value === reset) {
                delete localStorageUiSettings[key];
            } else {
                localStorageUiSettings[key] = value;
            }
        });
        LocalStoreHelper.setItem(
            uiSettingsLocalStorageKey,
            localStorageUiSettings,
        );
    }, [hash]);
};

type UiSettingsEntry = [string, string];

const reset = 'reset';
const uiSettingsHashParamsPrefix = 'ui-settings';

const uiSettingsLocalStorageKey = 'ui-settings';

export const getLocalStorageUiSettings = () => {
    return LocalStoreHelper.getItem(uiSettingsLocalStorageKey) || {};
};
